import React, { useState, useRef } from "react"
import Layout from "../../../components/Layout"
import SEO from "../../../components/SEO/SEO"
import NavRoad from "../../../components/NavBar/NavBar"
import SeeAlso from "../../../components/SeeAlso/SeeAlso"
import {
  Title,
  SubTitle,
  Button,
  Input,
  Span,
  Textarea,
  MessageParagraph,
} from "../../../StyleComponents/styles"
// import base32 from "base32";
import * as base32 from "hi-base32"

const navRoadArray = [
  { name: "Utility Tools", link: "/utility-tools/" },
  { name: "Base32 Decoder", link: "/base32-decoder/" },
]

const seeAlsoArray = [
  "/base32-encoder",
  "/base64-decoder",
  "/base64-encoder",
  "/binary-encoder",
]

function Base32Decoder(props) {
  let [input, setinput] = useState("")
  let [base64, setbase64] = useState("")
  let [errorElemnet, seterrorElemnet] = useState("")
  let fileName = useRef("")

  function inputC(e) {
    setinput(e.target.value)
    if (e.target.value !== "") {
      var binaryData = e.target.value

      let b32Regex = /^[A-Z2-7]+=*$/
      if (binaryData.length % 8 === 0 && b32Regex.exec(binaryData)) {
        var base64String = base32.decode(binaryData)
        setbase64(base64String)
        seterrorElemnet("")
      } else {
        seterrorElemnet("Please input Base32")
        setbase64("")
      }
    } else if (e.target.value === "") {
      seterrorElemnet("")
      setbase64("")
    }
  }

  function downloadObjectAsJson(exportName) {
    let myfileName = fileName.current.value
    if (myfileName === "") {
      exportName = "unitpedia-base32"
    } else {
      exportName = myfileName
    }
    if (base64 === "") {
      seterrorElemnet("Please make the conversion before download")
    } else {
      var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(base64)
      var downloadAnchorNode = document.createElement("a")
      downloadAnchorNode.setAttribute("href", dataStr)
      downloadAnchorNode.setAttribute("download", exportName + ".txt")
      document.body.appendChild(downloadAnchorNode) // required for firefox
      downloadAnchorNode.click()
      downloadAnchorNode.remove()
    }
  }
  return (
    <Layout location={props.location}>
      <SEO
        title="Base32 Decoder, Decoder Base32 Online"
        description="Base32 Decoder, Decoder Base32 Online, Simple Decoder Base32 step by step, And you can Encoder Base32 Fast and Easy."
        keywords={[
          "Base32 Decode, Base32 converter, Base32 Decoder, Base32 Decoder translator,Base32 Decoder online, fast Base32 Decoder,Base32 Decoder Encoder,Decoder Encoder,online Base32 Decoder,encode,decode.",
        ]}
      />
      <NavRoad listPages={navRoadArray} />

      <div className="container">
        <Title>Base32 Decoder</Title>
        <SubTitle>Decode Base32 online</SubTitle>

        <Span>Input to Decode Base32</Span>
        <Textarea value={input} onChange={inputC} />

        <MessageParagraph color="red">{errorElemnet}</MessageParagraph>
        <div>
          <Span>Output</Span>
          <Textarea value={base64} readOnly />
        </div>
        <br />
        <div>
          <Span>Filename </Span>
          <Input className="mb-3" width="150px" type="text" ref={fileName} />

          <Button
            borderColor="#1da1f2"
            color="#1da1f2"
            hoverColor="white"
            hoverBorderColor="#1da1f2"
            hoverBackgroundColor="#1da1f2"
            onClick={downloadObjectAsJson}
          >
            Download
          </Button>
        </div>
        <br />
        {/* <br />
        <div className="container" style={{ textAlign: "left" }}>
          <br />
          <h1 className="title fas mycolor">Base32</h1>
          <p>
            The Base32 allows to encode with 32 characters: <br />
            ABCDEFGHIJKLMNOPQRSTUVWXYZ234567 and the = symbol optionally used as
            the final character (as in Base64).
          </p>
        </div> */}
        <br />
        <SeeAlso seeAlsoList={seeAlsoArray} />
        <br />
      </div>
    </Layout>
  )
}

export default Base32Decoder
